module.exports = __webpack_public_path__ + "img/down-hn1.857416c0.jpg";